module.exports = __webpack_public_path__ + "static/DozenBear-3c2728a73dd257494b1c400673e82e7a.gif";